import type { NetSuiteConnectRequestPayload } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../../../services/api';

export function useNetSuiteConnect(
  options?: UseMutationOptions<void, unknown, NetSuiteConnectRequestPayload>,
) {
  return useMutation((netSuiteConnectRequest) => {
    const api = getPrivateApi();

    return api.netSuiteConnect({ netSuiteConnectRequest });
  }, options);
} 